/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonTagInfo,
    JsonTagInfoFromJSON,
    JsonTagInfoFromJSONTyped,
    JsonTagInfoToJSON,
} from './JsonTagInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonTagInfo
 */
export interface ApiResultOfListOfJsonTagInfo {
    /**
     * 
     * @type {Array<JsonTagInfo>}
     * @memberof ApiResultOfListOfJsonTagInfo
     */
    data?: Array<JsonTagInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTagInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonTagInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTagInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonTagInfo
     */
    result?: ApiResultOfListOfJsonTagInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonTagInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonTagInfoFromJSON(json: any): ApiResultOfListOfJsonTagInfo {
    return ApiResultOfListOfJsonTagInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonTagInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonTagInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonTagInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonTagInfoToJSON(value?: ApiResultOfListOfJsonTagInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonTagInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

